<template>
  <div id="rulesOfRegulationPage" class="container-fluid">
    <v-main class="container">
      <BackBar/>
      <div class="text-center font19px">
        <i class="fa-regular fa-comment-captions fa-lg"></i>
        انتقادات و پیشنهادات
      </div>
      <div class="mt-10">


        <div class="font16px my-2">نوع نظر</div>
        <v-autocomplete
            :items="typeItems"
            v-model="typeSelected"
            dense
            item-value="text"
            item-text="text"
            flat
            solo>
        </v-autocomplete>
        <div class="font16px my-2">عنوان نظر</div>
        <v-text-field
            class="rounded-lg"
            dense
            v-model="subject"
            flat
            solo>
        </v-text-field>
        <div class="font16px my-2">شرح نظر</div>

        <v-textarea
            v-model="description"
            auto-grow
            flat
            full-width
            hide-details
            rows="4"
            solo>
        </v-textarea>
        <v-btn class="float-left mt-4" color="primary" @click="submit">
          ثبت
        </v-btn>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary"
    >
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn icon @click="showResult = false "  v-bind="attrs">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "CriticsAndSuggestions",
  metaInfo: {
    title: 'ایوان خانه- انتقادات و پیشنهادات',
  },
  data:()=>({
    typeItems:[{id:1,text:'انتقاد'},{id:2,text:'پیشنهاد'}],
    showResult:false,
    showLoaderDialog:false,
    resultText:null,
    description:null,
    subject:null,
    typeSelected:'پیشنهاد',

  }),
  components: {BackBar},
  methods:{
    submit(){
      this.showLoaderDialog= true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("Subject", this.subject);
      urlencoded.append("TypeSuggestionCritic", this.typeSelected);
      urlencoded.append("Description", this.description);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Publicly/SuggestionCritic", requestOptions)
          .then(response => response.text())
          .then(result =>{
            this.showLoaderDialog= false
            this.resultText= result
            this.showResult= true
            this.description= null
            this.subject= null
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>